import { render, staticRenderFns } from "./MarketingGuide.vue?vue&type=template&id=e0382108&scoped=true&lang=pug"
import script from "./MarketingGuide.vue?vue&type=script&lang=js"
export * from "./MarketingGuide.vue?vue&type=script&lang=js"
import style0 from "./MarketingGuide.vue?vue&type=style&index=0&id=e0382108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0382108",
  null
  
)

export default component.exports